



import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  setup(_, { listeners }) {
    return { listeners };
  },
});
